<template>
   <div class="footer footervmargin" v-bind:class="{ sticktobottom: sticktobottom }" >
    <div class="footercontact">
      <div>
          {{company_name}}<br/>
          {{company_street}}<br/>
          {{company_cap}} {{company_city}} {{company_country}}<br/>
          {{company_tel}}<br/>
          <a :href="company_mailto">{{company_email}}</a><br/>
          {{company_vat}}
      </div>
    </div>
    <div class="footercopyright">Copyright {{new Date().getFullYear()}} <a :href="linkprivacy">Privacy and Cookie Policy</a></div>
  </div>
 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import companymixin from "../mixins/companymixin"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpfooter",
  mixins:[multilangmixin,companymixin],
  props:["sticktobottom"],

  data(){
      return {


            };
  },

  created(){
      //document.body.onscroll=this.fnOnResize();
      //window.onresize = this.fnOnResize();
  },

  computed:{

      linkprivacy()
      {
        return "https://privacy.newlablight.com/"+this.currentlang;
      }

  },


  methods:{
     /* fnOnResize()
      {
      
      }
      */
     
  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    


.footervmargin{
  margin-top: 30px;
}

.footer
{
  margin-left: 0px;
  margin-right: 0px;
  font-size: 0.7em;
  font-weight: bold;

  
  width: 100vw;
  
}


.footercontact
{
  padding-top: 20px;
  padding-left: 50px;
  padding-bottom: 10px;
  margin-left: 0px;
  margin-right: 0px;
  min-height: 70px;
  background-color: #ffdd00;
  
}

.footercontact a 
{
    color: black; 
    text-decoration: none;
}
 
.footercontact  a:visited{

  color: black;
  text-decoration: none;
}

.footercontact a:active{

  color: black;
  text-decoration: none;
}

.footercontact a:hover{

  color: black;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: white;
  text-decoration-thickness: 0.3em;
}

.footercopyright
{
  text-align: left;
  padding-top: 5px;
  padding-left: 50px;
  min-height: 30px;
  color: white; 
  background-color: #080808;
  
  line-height: 1.5;
}
 

.footercopyright a 
{
    color: white; 
    text-decoration: none;
}
 
.footercopyright  a:visited{

  color: white;
  text-decoration: none;
}

.footercopyright a:active{

  color: white;
  text-decoration: none;
}

.footercopyright a:hover{

  color: white;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: #ffdd00;
  text-decoration-thickness: 0.3em;
}

  



  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
 
    .sticktobottom
    {
      position: absolute;
      bottom: 0px;

    }


  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  
 
  }


</style>
